import { Type } from 'class-transformer'
import { IsInt, IsNumber, IsOptional, IsPositive, IsString } from 'class-validator'

export class SaveRestrictedLotDto {
  @IsOptional()
  @Type(() => Number)
  @IsNumber()
  @IsInt()
  @IsPositive()
  id?: number

  @IsString()
  name!: string
}
